import React, { useState, useEffect } from 'react'
import {
  BannerDescription,
  BannerDescriptionText,
  BannerDescriptionTextPink,
  BannerTitle,
  BannerTitleText,
  BannerTitleTextPink,
  BannerTitleTextSmall,
  BannerWrapper,
  CustomerFaceImage,
  LeftSideWrapper,
  Quote,
  RightSideWrapper,
} from './ClickceaseMigrationBanner.styled'
import { ConfirmPlanModal } from './components/ConfirmPlanModal/ConfirmPlanModal'
import { ExplainBox } from './components/ExplainBox/ExplainBox'
import { Button, useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import customerImage from 'Assets/images/customer-face.png'
import { boxesContent } from './helper'
import { useGetAccountMetadata } from './api/useGetAccountMetadata'
import { useAcceptOffer } from './api/useAcceptOffer'
import { LastMessageModal } from './components/LastMessageModal'
import { AxiosError } from 'axios'

let trackingEventSent = false

export const ClickceaseMigrationBanner = () => {
  const { t } = useTranslation('limitedOfferBanner')
  const { data } = useGetAccountMetadata()
  const { mutate, data: acceptOfferData, isLoading } = useAcceptOffer()
  const { track } = useFrontEndEventTrackingService()
  const [confirmPlanModalOpen, setConfirmPlanModalOpen] = useState(false)
  const [lastMsgModalOpen, setLastMsgModalOpen] = useState(false)

  useEffect(() => {
    if (!trackingEventSent) {
      track(['segment'], 'Essentials view banner', {})
      trackingEventSent = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onAcceptOffer = () =>
    mutate(undefined, {
      onSettled() {
        setConfirmPlanModalOpen(false)
        setLastMsgModalOpen(true)
      },
    })

  return (
    <BannerWrapper>
      <LeftSideWrapper>
        <BannerTitle>
          <BannerTitleTextSmall>{t('title.welcome')}</BannerTitleTextSmall>
          <BannerTitleTextPink>{t('title.cheq')}</BannerTitleTextPink>
          <BannerTitleText>{t('title.essentials')}</BannerTitleText>
        </BannerTitle>
        <BannerDescription>
          <BannerDescriptionText>{t('description.get_offer')}</BannerDescriptionText>
          <BannerDescriptionTextPink>
            {t('description.offer', { offer: data?.essentialsDiscountPercentage })}
          </BannerDescriptionTextPink>
        </BannerDescription>
        <Button
          text={t('new_plan_btn')}
          size="lg"
          style={{ marginTop: '68px' }}
          onClick={() => setConfirmPlanModalOpen(true)}
        />
      </LeftSideWrapper>
      <RightSideWrapper>
        <Quote>{t('quote')}</Quote>
      </RightSideWrapper>
      {boxesContent.map((boxContent, index) => (
        <ExplainBox
          key={index}
          text={boxContent.text}
          value={boxContent.value}
          style={boxContent.style}
        />
      ))}
      <CustomerFaceImage src={customerImage} />
      {data?.essentialsDiscountPrice && (
        <ConfirmPlanModal
          isOpen={confirmPlanModalOpen}
          setIsOpen={setConfirmPlanModalOpen}
          onConfirm={onAcceptOffer}
          loading={isLoading}
        />
      )}
      {!!acceptOfferData && (
        <LastMessageModal
          isOpen={lastMsgModalOpen}
          setIsOpen={setLastMsgModalOpen}
          isError={acceptOfferData instanceof AxiosError}
        />
      )}
    </BannerWrapper>
  )
}
